import create from 'zustand';

const GRADE_PROFILE_INITIAL = {
	grade: {
		id: 0,
		title: '',
		titlePublic: '',
		number: '',
		programId: 0,
		price: ''
	},
	program: {
		id: 0,
		title: '',
		titleWhat: '',
	}
};

export const useGradeProfileStore = create(set => ({
	...GRADE_PROFILE_INITIAL,

	// Initialize grade's state
	onInit: (grade) => set((state) => ({
		grade: {
			id: grade?.id,
			title: grade?.title,
			titlePublic: grade?.titlePublic,
			number: grade?.number,
			programId: grade?.programId,
			price: grade?.price
		},
		program: grade.program ? {
			id: grade.program?.id,
			title: grade.program?.title,
			titleWhat: grade.program?.titleWhat,
			contractNumber: grade.program?.contractNumber
		} : {
			...state.program
		},
	})),

	// Update grade's state
	onUpdate: (updated) => set(state => ({
		grade: {
			...state.grade,
			...updated
		}
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_PROFILE_INITIAL
	})
}));